export default "__VITE_ASSET__D65OfOV1__"